import Api from "../../utils/axios";




export const productApi = {
  getSingleProduct: (productId) => Api.get(`user/get-product/${productId}`), // Fetching the data without JWT token
  getReviewForProduct: (id, payload) =>Api.post(`user/get-all-products-rating-review/${id}`, payload) ,// Fetching the data without JWT token
  getProductById: (id) => Api.get(`product/get-product-by-id/${id}`),
};

